
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { AuthMode, LoginProvider } from '@/utils/models';

@Component({})
export default class ZawaOperationalLogin extends Vue {
  @Prop({ default: '' }) authMode!: AuthMode;
  @Prop({ default: [] }) providers!: LoginProvider[];
  @Prop({ default: '' }) userId!: string;
  guestName = '';

  get isGuestFormValid(): boolean {
    return !!this.guestName;
  }

  @Emit('onLoginWithProvider') onLoginWithProvider(id: string) {}

  @Emit('onLoginAsGuest')
  onLoginAsGuest(name: string) {}
}
